<template>
  <div class="foot">
    <div>
      <!-- <p class="flex-a"><i class="el-icon-phone"
          style="color:#5280FF;font-size: 24px;"></i><span>客服电话：0798-8279069</span></p> -->
      <p class="flex-a"><i class="el-icon-location"
          style="color:#5280FF;font-size: 24px;"></i><span>公司地址：江西省景德镇市珠山区广场南路皇冠购物广场西三区1-5号楼三层办公室</span></p>
    </div>
    <div class="link">
      <span>友情链接：</span> <a href="https://ggzy.jiangxi.gov.cn/web/" target="_blank">江西公共资源交易网</a>| <a
        href="http://www.jdzggzyjyzx.cn/" target="_blank">景德镇市公共资源交易中心</a>
    </div>
    <div>景德镇市景纬数创科技发展有限责任公司</div>
    <div class="link"><a target="_blank" href="https://beian.miit.gov.cn">赣ICP备2022007678号</a></div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  components: {},
  props: {

  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {

  },
  computed: {

  }
}
</script>

<style lang="less">
.foot {
  width: 100%;
  background: #0C5BBB;
  padding: 10px 20%;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 22px;

  .link {
    a {
      color: #fff;
      margin: 0 15px;
    }
  }
}
</style>
